<div class="css-filters-dialog" data-test-id="css-filters-dialog">
  <ul #sortableRef>
    <!--suppress TypeScriptValidateTypes -->
    <li
      *ngFor="let item of filters | keyvalue: orderFunc; trackBy: trackByFunc"
      [attr.data-id]="item.key"
      [class.active]="item.key === filter"
      (click)="onChangeFilter(item.key)"
    >
      <div class="item-key">
        <button class="btn css-filters-handle" (click)="noop($event)">
          <span class="material-icons-round notranslate">drag_handle</span>
        </button>
        <span class="item-text">{{ item.key | case: "start" }}</span>
      </div>

      <div class="item-value">
        <ng-container *appVar="item.value.value - (defaultCssFilters | filterValue: item.key) as diff">
          <span
            *ngIf="diff > 0"
            class="diff"
            [title]="(diff | number: '1.' + item.value.dp) + item.value.uom.displayUnit + ' up on default'"
          >
            <span class="material-icons-round notranslate">arrow_drop_up</span>
          </span>
          <span
            *ngIf="diff < 0"
            class="diff"
            [title]="(diff | abs | number: '1.' + item.value.dp) + item.value.uom.displayUnit + ' down on default'"
          >
            <span class="material-icons-round notranslate">arrow_drop_down</span>
          </span>
        </ng-container>
        <span>{{ item.value.value | number: "1." + item.value.dp }}</span>
        <span>{{ item.value.uom.displayUnit }}</span>
      </div>
    </li>
  </ul>

  <div class="buttons">
    <button class="btn btn-secondary btn-sm btn-reset-all" (click)="onResetAll()">Reset All</button>
  </div>
  <div class="color-blind-buttons">
    <button (click)="protanopia()">Protanopia</button>
    <button (click)="deuteranopia()">Deuteranopia</button>
    <button (click)="tritanopia()">Tritanopia</button>
    <button (click)="achromatopsia()">Achromatopsia</button>
  </div>

  <ng-container *ngIf="target">
    <div class="target">
      <div class="form-check">
        <input id="images-only" class="form-check-input" type="checkbox" [ngModel]="targetValue" (ngModelChange)="onUpdateTarget($event)" />
        <label for="images-only" class="form-check-label">Apply filters to images only</label>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!dismissed">
    <div class="info-panel">
      <span>Drag handle to change<br />filter order</span>
      <button class="btn btn-dismiss" (click)="dismiss()">&times;</button>
    </div>
  </ng-container>
</div>
